import { render, staticRenderFns } from "./TraceTabs.vue?vue&type=template&id=20fdd031"
import script from "./TraceTabs.vue?vue&type=script&lang=js"
export * from "./TraceTabs.vue?vue&type=script&lang=js"
import style0 from "./TraceTabs.vue?vue&type=style&index=0&id=20fdd031&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports